import React from 'react';
import './Home.css'; // Assurez-vous de créer et d'utiliser ce fichier CSS
import Categories from '../components/Categories';
import Recommendations from '../components/Recommendations';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
// import Header from '../components/Header';


const Home = () => {
  return (
    <div className="home">
      {/* Section Hero */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">TRINITY</h1>
          <p className="hero-subtitle">Your all-in-one go-to-shop</p>
        </div>
      </section>
      <section>
        <Categories/>
      </section>
      <Recommendations/>
      <Testimonials/>
      <Footer/>
    </div>
  );
};


export default Home;


